import GameKeySeller from "@/components/compatibility/GameKeySeller";
import { useGameResellKeyCounts } from "@/hooks/useGameResell";
import { useTrans } from "@/utils/useTrans";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/v2-components/ui/dialog";
import Image from "next/image";
import { BhapticsContent } from "@/store/reducers/contents";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  content: BhapticsContent;
}

export default function SelectGameKeyDialog({
  open,
  onOpenChange,
  content,
}: Props) {
  // 다이얼로그가 열리고 gameResell이 있을 때만 keyCounts를 가져옴
  const keyCounts = useGameResellKeyCounts(
    open && content.gameResell?.id ? content.gameResell.id : "",
  );
  const { t } = useTrans(["gnb"]);

  if (!content.gameResell) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[400px] overflow-hidden px-6 pb-0 pt-0 laptop:h-auto [@media(max-height:700px)]:h-[calc(80vh)]">
        <DialogHeader className="z-10 w-full bg-white pt-6">
          <DialogTitle>{t("Choose Your Platform")}</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <GameKeySeller
          gameResell={content.gameResell}
          // 재고는 접지 않고 그대로 넘긴다 — 조회 중 · 모름(`undefined`/`null`)이면 GameKeySeller 가 담기를
          // 막는다. 종전 `?? []` 와 「재고 행이 없으면 판다」 판정이 겹쳐, 첫 열기의 로딩 중 · 조회 실패에도
          // 가격 있는 플랫폼을 전부 팔았다(#5942 리뷰).
          keyCounts={keyCounts.data}
          className="-mx-6 flex flex-col overflow-y-auto laptop:gap-0"
          // 이 다이얼로그는 게임 목록·카드에서만 열린다(카드 7곳). 게임 상세 히어로는
          // `GameKeySeller` 를 직접 그리며 `game_detail` 을 쓴다 (#5292).
          trigger="product_card"
        >
          <div className="px-6 pb-32">
            <h3 className="pb-2 text-base font-600">{content.name}</h3>
            <DialogDescription className="flex-1 text-base">
              {t("Please select a platform for your purchase.")}
            </DialogDescription>
            <div className="relative my-6 aspect-[352/164] overflow-hidden rounded-[10px]">
              <Image
                src={content.thumbnailWideLink}
                alt={content.name}
                className="object-cover"
                fill
              />
            </div>
            <GameKeySeller.RadioGroup />
          </div>
          <div className="absolute bottom-0 w-full bg-white px-6 py-6">
            <GameKeySeller.Button
              className="w-full"
              onClickEnd={() => {
                onOpenChange(false);
              }}
            />
          </div>
        </GameKeySeller>
      </DialogContent>
    </Dialog>
  );
}
